export default __webpack_public_path__ + "static/media/tutrial1.5024ecd1.gif";